import { getRedirectUrl } from 'customHelpersPath/creditTools.helper';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { SUBSCRIPTION_VERTICAL } from 'types/mrph.vertical.constants';
import { CREDIT_TOOLS } from 'types/morph.pagePosition.constants';
import { setShouldShowExpandedEngagementModule } from 'helpers/sessionstorage';

export const useCreditTools = ({
  history,
  eventHandler,
  userInfo,
  cashAccount,
}) => {
  const onClickCreditTools = ({ tileInfo, isDssTile = false }) => {
    const redirectUrl = getRedirectUrl({ tileInfo, userInfo, cashAccount });
    history?.push(redirectUrl);
    setShouldShowExpandedEngagementModule(false);

    const clickType = userInfo?.premiumAccount ? 'Plus' : 'Free';
    eventHandler(CLICK, {
      'Module Name': CREDIT_TOOLS,
      'Click Type': `${clickType} - ${tileInfo?.title}`,
      Vertical: SUBSCRIPTION_VERTICAL,
    });
  };

  const goToPremium = () => {
    history?.push('/premium');
  };

  return { onClickCreditTools, goToPremium };
};
